import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { TUserMeta, TUserMetaResponse, adaptUserMetaFromResponse } from './user-meta.type';
import { adaptApplicationSourceFromResponse, TApplicationSource, TApplicationSourceResponse } from './application-source.type';


export const ApplicationUserRelationListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TApplicationUserRelationListSortCol = TTableSortCols<typeof ApplicationUserRelationListSortCol>;

export type TApplicationUserRelationListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TApplicationUserRelationListSortCol;
};

export type TApplicationUserRelationListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptApplicationUserRelationListQueryToRequest(data?: TApplicationUserRelationListQuery): TApplicationUserRelationListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TApplicationUserRelation = {
  id: number;
	createdAt: string;
  updatedAt: string;

  application: TApplicationSource;
  user: TUserMeta;
	// createdBy?: TUserMeta;
	// updatedBy?: TUserMeta;
};

export type TApplicationUserRelationResponse = {
  id: number;
  created_at: string;
  updated_at: string;

  application: TApplicationSourceResponse;
  user: TUserMetaResponse;
	// created_by?: TUserMetaResponse;
	// updated_by?: TUserMetaResponse;
};

export type TApplicationUserRelationListResponse = TListResponse<TApplicationUserRelationResponse>;

export type TApplicationUserRelationList = TListResponse<TApplicationUserRelation>;

export type TApplicationUserRelationPayloadRequest = {
	userNickname: string;
	applicationId: number;
};

export type TApplicationUserRelationRequest = {
	user_nickname: string;
	application_id: number;
};

export type TApplicationUserRelationPayloadUpdate = {
	id: number;
	data: TApplicationUserRelationPayloadRequest;
};

export function adaptApplicationUserRelationFromListResponse(data: TApplicationUserRelationListResponse): TApplicationUserRelationList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptApplicationUserRelationFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptApplicationUserRelationFromResponse(data: TApplicationUserRelationResponse): TApplicationUserRelation {
	const {
		id,
		application: applicationRaw,
		user: userRaw,
		created_at: createdAt,
		updated_at: updatedAt,
		// created_by: createdByRaw,
		// updated_by: updatedByRaw,
	} = data;

	const application = adaptApplicationSourceFromResponse(applicationRaw);
	const user = adaptUserMetaFromResponse(userRaw);
	// const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	// const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		application,
		user,
		createdAt,
		updatedAt,
		// createdBy,
		// updatedBy,
	};
}

export function adaptApplicationUserRelationToRequest(data: TApplicationUserRelationPayloadRequest): TApplicationUserRelationRequest {
	const {
		userNickname,
		applicationId,
	} = data;

	return {
		user_nickname: userNickname,
		application_id: applicationId,
	};
}
